import type { ReactNode } from "react";

import clsx from "clsx";

import styles from "./page-header.module.css";

type PageHeaderProps = {
	children?: ReactNode;
	className?: string;
	title: string;
};
export function PageHeader({ children, className, title }: PageHeaderProps): ReactNode {
	return (
		<header className={clsx(styles.header, className)}>
			<h1 className="title-1">{title}</h1>
			{children}
		</header>
	);
}
